// ===========================================
// konakla - Sentry ortam adı
// ===========================================
//
// NEDEN VAR (D-16): üç Sentry yapılandırması da `environment: process.env.NODE_ENV`
// kullanıyordu. Vercel preview dağıtımlarında `NODE_ENV` **"production"**tır —
// yani preview'da oluşan hatalar Sentry'de gerçek production hatalarından
// AYIRT EDİLEMİYORDU. Bir preview'daki yarım kalmış deneme, canlıda sorun var
// izlenimi veriyor; gerçek bir production hatası da preview gürültüsünün
// içinde kaybolabiliyor.
//
// Vercel `VERCEL_ENV` değişkenini "production" | "preview" | "development"
// olarak sağlar. Tarayıcı tarafında yalnızca `NEXT_PUBLIC_*` önekli değişkenler
// pakete gömüldüğü için orada `NEXT_PUBLIC_VERCEL_ENV` okunur (Vercel'in
// "System Environment Variables" ayarı bunu otomatik sağlar).
//
// Tek yerde tutulmasının sebebi: kod tabanında aynı yardımcının üç kopyasının
// zamanla birbirinden ayrışması bu denetimde defalarca görüldü.

/**
 * Sentry'ye bildirilecek ortam adı.
 *
 * Sıra: `NEXT_PUBLIC_VERCEL_ENV` (tarayıcı + sunucu) → `VERCEL_ENV` (sunucu/edge)
 * → `NODE_ENV` → `"development"`.
 *
 * ⚠️ `NEXT_PUBLIC_*` değişkenleri BUILD sırasında gömülür; Vercel'de değeri
 * değişirse yeniden dağıtım gerekir.
 */
export function sentryEnvironment(): string {
  return (
    process.env.NEXT_PUBLIC_VERCEL_ENV ??
    process.env.VERCEL_ENV ??
    process.env.NODE_ENV ??
    "development"
  );
}
